import React from 'react';
import ClassProjects from '../../components/class-project/ClassProjects';
import styles from './ClassProjects.module.scss'
import { Link } from '@reach/router';

import navigationIcon from '../../../../images/new-dashboard/navigation-icon.svg';
import classProjects from '../../../../images/new-dashboard/class-projects.svg';

import { useQuery } from '@apollo/react-hooks';
import moment from 'moment';
import { MAIN_DASHBOARD_QUERY } from '../../services/graphql';
import { BOOK_STATUS } from '@squirrellearningltd/go-shared-utils';

const ClassProjectsPage = () => {

    const { data, loading, error } = useQuery(MAIN_DASHBOARD_QUERY, {
        fetchPolicy: 'cache-and-network',
    });

    const getBooks = () => {
        const filteredBooks = [];
        const books = data?.currentStudent?.books;

        if (!books) {
            return filteredBooks;
        }

        books.forEach(book => {
            if (book.status < BOOK_STATUS.completed || (book.completedAt && moment(book.completedAt).isBefore(moment().subtract(2, 'days').startOf('day')))) {
                filteredBooks.push(book);
            }
        })
        return filteredBooks;
    }


    return <div className={styles.classProjectsPageContainer}>
        <div className={styles.classProjectTilteContainer}>
            <div className={styles.classProjectTilteContainer}>
                <img src={classProjects} alt='Class Projects Icon' />
                <h2 className={styles.classProjectsHeadline}>Current Class Projects</h2>
            </div>

            <Link to='/' >
                <div className={styles.classProjLinkContianer}>
                    <h3 className={styles.classProjLinkTitle}>Back to Write</h3>
                    <img src={navigationIcon} alt='Navigation Icon' />
                </div>
            </Link>
        </div>
        <ClassProjects books={getBooks()} />
    </div>
}

export default ClassProjectsPage;